import React from "react";
import { CmpDatePickerField001V1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";

export default function Header({
  filters,
  handleChange,
  onLoad,
  vRdxuserLoc,
  apiRef,
  status,
}) {
  const isMobile = useMediaQuery("(max-width:650px)");
  const handleExport = () => {
    apiRef.current.exportDataAsCsv(); // or exportDataAsExcel(), etc.
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

  return (
    <>
      {!isMobile && (
        <Typography
          variant="h6"
          gutterBottom
          color={"primary"}
          sx={{ fontWeight: 600 }}
        >
          Purchase
        </Typography>
      )}

      <Grid container spacing={1.5} mt={isMobile ? 0 : 1}>
        <Grid item xs={12} sm={3} md={1.7}>
          <CmpDatePickerField001V1
            xLabelText="From date"
            xValue={filters.fromDate}
            xOnChange={(newValue) => {
              handleChange("fromDate", newValue?.$d);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={1.7}>
          <CmpDatePickerField001V1
            xLabelText="To date"
            xValue={filters.toDate}
            xOnChange={(newValue) => {
              handleChange("toDate", newValue?.$d);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel id="loc">Location</InputLabel>
            <Select
              labelId="loc"
              label="Location"
              value={filters.location}
              onChange={(e) => handleChange("location", e?.target?.value)}
            >
              {vRdxuserLoc?.map((loc) => (
                <MenuItem key={loc?.UID} value={loc?.UID}>
                  {loc?.Name1}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3} md={1.8}>
          <FormControl fullWidth size="small">
            <InputLabel id="status">Status</InputLabel>
            <Select
              labelId="status"
              label="Status"
              value={filters.status}
              onChange={(e) => handleChange("status", e?.target?.value)}
            >
              {status?.map((s) => (
                <MenuItem key={s} value={s}>
                  {s}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          item
          xs={8}
          sm={9}
          md={3.8}
          sx={{
            display: "flex",
            alignItems: isMobile ? "center" : "flex-end",
            textAlign: isMobile ? "center" : "end",
            justifyContent: isMobile ? "center" : "flex-end",
          }}
        >
          <Stack
            direction={"row"}
            spacing={{ xs: 0.5, md: 1 }}
            flexWrap={"wrap"}
          >
            <Button variant="contained" size="small" onClick={onLoad}>
              Load
            </Button>
            <Button variant="contained" size="small" onClick={handleExport}>
              Export
            </Button>
            <Button variant="contained" size="small" onClick={handlePrint}>
              Print
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
}
